export default __webpack_public_path__ + "static/media/Image2.5feaa464.png";